"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withoutLastOfType = exports.withoutLast = exports.whenHovering = exports.visuallyHidden = exports.size = exports.showOnHover = exports.scrollbars = exports.proportional = exports.placeholder = exports.oneOf = exports.noSelect = exports.minSize = exports.line = exports.iconSize = exports.ellipsisWrap = exports.ellipsis = exports.displayOnHover = exports.cond = exports.circle = exports.absoulteFull = void 0;
var _flex = _interopRequireDefault(require("../styles/flex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var cond = exports.cond = function cond(condition, rule) {
  return condition ? rule : '';
};
var withoutLast = exports.withoutLast = function withoutLast(rule, lastRule) {
  return "\n  ".concat(rule, "\n\n  &:last-child {\n    ").concat(lastRule, "\n  }\n");
};
var withoutLastOfType = exports.withoutLastOfType = function withoutLastOfType(rule, lastRule) {
  return "\n  ".concat(rule, "\n\n  &:last-of-type{\n    ").concat(lastRule, "\n  }\n");
};
var oneOf = exports.oneOf = function oneOf(prop, obj) {
  return "".concat(obj[prop], ";");
};
var placeholder = exports.placeholder = function placeholder(style) {
  return "\n  &::-webkit-input-placeholder {\n   ".concat(style, "\n  }\n\n  &:-moz-placeholder {\n    ").concat(style, "\n  }\n\n  &::-moz-placeholder {\n    ").concat(style, "\n  }\n\n  &:-ms-input-placeholder {\n    ").concat(style, "\n  }\n");
};
var noSelect = exports.noSelect = "\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n";
var proportional = exports.proportional = function proportional() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return "\n  &:after {\n    content: \"\";\n    display: block;\n    padding-bottom: ".concat(p * 100, "%;\n  }\n");
};
var absoulteFull = exports.absoulteFull = "\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n";
var whenHovering = exports.whenHovering = function whenHovering(className, rule) {
  return "\n  &:hover {\n    .".concat(className, " {\n      ").concat(rule, "\n    }\n  }\n");
};
var showOnHover = exports.showOnHover = function showOnHover(className) {
  return whenHovering(className, 'opacity: 1;');
};
var displayOnHover = exports.displayOnHover = function displayOnHover(className) {
  var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
  return whenHovering(className, "display: ".concat(display, " !important;"));
};
var ellipsis = exports.ellipsis = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";

// Truncates long words, but preserves lines
var ellipsisWrap = exports.ellipsisWrap = "\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var iconSize = exports.iconSize = function iconSize(iconSz) {
  var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : size;
  return "\n  font-size: ".concat(fontSize, "px !important;\n  height: ").concat(iconSz, "px;\n  width: ").concat(iconSz, "px;\n");
};
var line = exports.line = function line() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'gray';
  var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return "\n  height: ".concat(lineHeight, "px;\n  border: none;\n  background-color: ").concat(color, ";\n");
};
var size = exports.size = function size(sizePx) {
  return "\n  width: ".concat(sizePx, "px;\n  height: ").concat(sizePx, "px;\n");
};
var minSize = exports.minSize = function minSize(sizePx) {
  return "\n  min-width: ".concat(sizePx, "px;\n  min-height: ").concat(sizePx, "px;\n");
};
var circle = exports.circle = function circle(circleSize) {
  return "\n    border-radius: 100%;\n    text-align: center;\n    ".concat(_flex["default"].horizontal, "\n    ").concat(_flex["default"].centerHorizontal, "\n    ").concat(size(circleSize), "\n    ").concat(minSize(circleSize), "\n    line-height: ").concat(circleSize, "px;\n");
};
var scrollbars = exports.scrollbars = "\n  overflow: auto;\n  -webkit-overflow-scrolling: touch\n";
var visuallyHidden = exports.visuallyHidden = "\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n";
//# sourceMappingURL=sc-utils.js.map